import type {
    StackProps as _StackProps,
    StackDividerProps as _StackDividerProps,
} from "@chakra-ui/react";
import {
    forwardRef,
    Stack as _Stack,
    HStack as _HStack,
    VStack as _VStack,
    StackDivider as _StackDivider,
} from "@chakra-ui/react";

export interface StackProps extends _StackProps {}

export interface StackDividerProps extends _StackDividerProps {}

export const Stack = forwardRef<StackProps, "div">(({ ...props }, ref) => (
    <_Stack ref={ref} {...props} />
));

export const HStack = forwardRef<StackProps, "div">(({ ...props }, ref) => (
    <_HStack ref={ref} {...props} />
));

export const VStack = forwardRef<StackProps, "div">(({ ...props }, ref) => (
    <_VStack ref={ref} {...props} />
));

export const StackDivider = forwardRef<StackDividerProps, "div">(({ ...props }, ref) => (
    <_StackDivider ref={ref} {...props} />
));
